import * as ActionTypes from './actionType.js';

const reducerMap = {
    [ActionTypes.GET_USER_REQUEST]: (state) => {
        return Object.assign({}, state, {
            fetchStatus: true,
            error: ''
        });
    },
    [ActionTypes.GET_USER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            fetchStatus: false,
            ...payload.data,
            product:payload.product,
        });
    },
    [ActionTypes.GET_USER_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            fetchStatus: false,
            error: payload
        });
    },
    [ActionTypes.PATH_CHANGE]: (state, payload) => {
        return Object.assign({}, state, {
            path: payload,
        });
    },
    [ActionTypes.SET_LIVE_TOKEN]: (state, payload) => {
        return Object.assign({}, state, {
            liveToken: payload,
        });
    },
}
export const INITIALIZE_STATE = {
}
const reducer = (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};
export default reducer


// WEBPACK FOOTER //
// ./src/entry_app/reducer.js